const secondsToMilliseconds = (seconds = 0) => seconds * 1000;

export default secondsToMilliseconds;
